import {
    setWidthAction,
    setHeightAction,
    setDiameterAction,
    setSpeedIndexAction,
    setLoadIndexAction,
    setPostcodeAction
} from '../../_flux/actions/catalog_configurator_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { resetFiltersAfterFilter } from './reset_filters_after_change';
import { checkNextEmptyValueAvailable } from './check_next_empty_value_available';

export function onConfiguratorValueChangeFactory(productType) {
    return (newValue, filterToUpdate) => {
        resetFiltersAfterFilter(filterToUpdate, productType);

        switch (filterToUpdate) {
            case Filters.WIDTH:
                setWidthAction(newValue, productType);
                break;
            case Filters.HEIGHT:
                setHeightAction(newValue, productType);
                break;
            case Filters.DIAMETER:
                setDiameterAction(newValue, productType);
                break;
            case Filters.SPEED_INDEX:
                setSpeedIndexAction(newValue, productType);
                break;
            case Filters.LOAD_INDEX:
                setLoadIndexAction(newValue, productType);
                break;
            case Filters.POSTCODE:
                setPostcodeAction(newValue, productType);
                break;
        }

        checkNextEmptyValueAvailable(filterToUpdate, productType);
    }
}
